import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "b-blue-background b-blue-background__opacity b-blue-background--fixed" }
const _hoisted_2 = { class: "h-flex-dir-column h-flex-center" }
const _hoisted_3 = { class: "h-font-22 h-mt-0 h-mb-0 h-text-center" }
const _hoisted_4 = {
  key: 0,
  class: "h-mv-20 h-text-center"
}
const _hoisted_5 = {
  key: 1,
  class: "h-mt-10 h-mb-20 h-text-center h-fw-500"
}
const _hoisted_6 = {
  key: 2,
  class: "h-mt-10 h-mb-20 h-text-center h-fw-500 b-text-error"
}
const _hoisted_7 = {
  key: 3,
  class: "h-mv-0 h-pl-0"
}
const _hoisted_8 = {
  key: 0,
  class: "h-fw-500 h-mv-10"
}
const _hoisted_9 = { class: "h-font-14" }
const _hoisted_10 = {
  key: 1,
  class: "h-fw-500 h-mv-10"
}
const _hoisted_11 = {
  style: {"text-decoration":"underline"},
  class: "h-font-14"
}
const _hoisted_12 = { class: "h-flex h-flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FwButton = _resolveComponent("FwButton")!
  const _component_FwPopup = _resolveComponent("FwPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FwPopup, {
      centered: true,
      isFixed: true,
      iconColor: "#BEC7D4",
      maxWidth: _ctx.maxWidth,
      width: "auto",
      title: "",
      allowBackgroundScrolling: true,
      showClosePopup: true,
      popupBackground: "#F8F9FA",
      popupRadius: "20px",
      heightValue: "100%",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit("close")))
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "imageHeader"),
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.headerText), 1),
          (_ctx.bodyText)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.bodyText), 1))
            : _createCommentVNode("", true),
          (_ctx.subMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('WORKER.POPUP.INVITATION.CHECK')), 1))
            : _createCommentVNode("", true),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1))
            : _createCommentVNode("", true),
          (_ctx.listToApprove)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                (!_ctx.workingHours)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                      _createTextVNode(" - " + _toDisplayString(_ctx.$t('WORKER.POPUP.INVITATION.CHECK.ITEM.HOURS.TITLE')) + " ", 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('WORKER.POPUP.INVITATION.CHECK.ITEM.HOURS.TEXT')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.addressConfirm)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                      _createTextVNode(" - " + _toDisplayString(_ctx.$t('WORKER.POPUP.INVITATION.CHECK.ITEM.ADDRESS.TITLE')) + " ", 1),
                      _createVNode(_component_router_link, {
                        to: `/consult/companies/edit/${_ctx.companyId}`
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('WORKER.POPUP.INVITATION.CHECK.ITEM.ADDRESS.TEXT')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_FwButton, {
            class: "h-mt-20",
            borderRadiusType: "small-border",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("close") && _ctx.goToPage()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 3
    }, 8, ["maxWidth"])
  ]))
}